import script from "./UiPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./UiPanel.vue?vue&type=script&setup=true&lang=js"

import "./UiPanel.vue?vue&type=style&index=0&id=074fdbe4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-074fdbe4"]])

export default __exports__